import { EmpresaService } from './src/services/empresas.services';
export const empresaService = new EmpresaService();
export default empresaService;
